import React from "react";
import PropTypes from "prop-types";
const AddFolderIcon = ({
  width,
  size,
  height,
  style,
  color,
  noPointer,
  title,
  ...props
}) => (
  <svg
    {...props}
    data-no-pointer={noPointer}
    width={width || size || 24}
    height={height || size || 24}
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby="title"
    fill={color || "var(--color-easil-gray-x-dark)"}
  >
    <title>{title}</title>
    <g
      id="DESIGNS-+-Proto"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group-33">
        <rect id="Rectangle-81" x="0" y="0" width="16" height="16" />
        <g id="Group-9">
          <rect id="Rectangle-71" x="0" y="0" width="16" height="16" />
          <path
            d="M9,12 L14,12 L14,5 L11,5 C10.4956591,5 10.009938,4.80945767 9.64012087,4.46653631 L6.98013073,2 L4,2 L4,7 C4,7.55228475 3.55228475,8 3,8 C2.44771525,8 2,7.55228475 2,7 L2,1.6 C2,0.7163444 2.7163444,-6.93614729e-12 3.6,-7.81219534e-12 L7.13704576,-6.78346268e-13 C7.54051851,-2.42659741e-13 7.92909534,0.152433861 8.22494906,0.426770949 L11,3 L14.4,3 C15.2836556,3 16,3.7163444 16,4.6 L16,12.4 C16,13.2836556 15.2836556,14 14.4,14 L9,14 C8.44771525,14 8,13.5522847 8,13 C8,12.4477153 8.44771525,12 9,12 Z"
            id="Combined-Shape"
            fill={color || "var(--color-easil-gray-x-dark)"}
            fillRule="nonzero"
          />
          <path
            d="M2,12 L2,11 C2,10.4477153 2.44771525,10 3,10 C3.55228475,10 4,10.4477153 4,11 L4,12 L5,12 C5.55228475,12 6,12.4477153 6,13 C6,13.5522847 5.55228475,14 5,14 L4,14 L4,15 C4,15.5522847 3.55228475,16 3,16 C2.44771525,16 2,15.5522847 2,15 L2,14 L1,14 C0.44771525,14 6.76353751e-17,13.5522847 0,13 C-6.76353751e-17,12.4477153 0.44771525,12 1,12 L2,12 Z"
            id="Combined-Shape"
            fill={color || "var(--color-easil-gray-x-dark)"}
          />
        </g>
      </g>
    </g>
  </svg>
);
AddFolderIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  size: PropTypes.string,
  height: PropTypes.string,
  style: PropTypes.object,
  color: PropTypes.string
};

export default AddFolderIcon;
